const en = {
    enter_code: "Session ID",
    connect: "Connect",
    check_your_internet_connection: "Check your Internet Connection.",
    network_error: "Network Error",
    server_error: "Server Error",
    check_server_connection: "Internal server error",
    downtime: "Down Time",
    server_is_currently_facing_downtime: "Server is currently facing downtime",
    show_what_you_see: "Show what you see",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "I confirm that I have read and agree to the Privacy Policy.",
    privacy_policy: "Privacy Policy",
    invalid_code: "Invalid Session ID",
    code_should_be_of_nine_digits: "Session ID should be of 9 digits",
    blitzz: "Blitzz",
    please_enter_your_name: "Please enter your Name",
    maximum_value_is_30: "Name should be less than 30 characters.",
    please_enter_meeting_id: "Please enter your CODE",
    please_try_again: "Please try again.",
    no_one_is_sharing_video: "No one is sharing video.",
    retry: "Retry",
    reconnect: "Re-Connect",
    left_the_conversation: "left the conversation",
    enabled_the_audio: "enabled the audio",
    disabled_the_audio: "disabled the audio",
    enabled_the_video: "enabled the video",
    disabled_the_video: "disabled the video",
    failed_to_join_room: "Failed to join room",
    alert: "Alert",
    override_video_sharing_message: "Would you like to end the current screen share and start sharing your video?",
    override_screen_sharing_message: "Would you like to end the current screen sharing and start sharing your screen?",
    override_video_sharing_with_screen_capturing_message: "Would you like to end the current video and start sharing your screen?",
    override_screen_sharing_with_video_sharing_message: "Would you like to end the current screen share and start sharing your video?",
    yes: "Yes",
    cancel: "Cancel",
    joined_the_call: "joined the call",
    waiting_for_other_members_to_join_the_call: "Waiting for other members to join the call",
    warning: "Warning",
    camera_permission_disabled: "Unable to access camera.",
    microphone_permission_disabled: "Unable to access microphone.",
    location_permission_disabled: "Unable to access location.",
    storage_permission_disabled: "Unable to access storage",
    permission_error_message_camera: "Please enable camera from device settings.",
    permission_error_message_microphone: "Please enable microphone from device settings.",
    permission_location_error_message: "Please enable location from device settings.",
    permission_storage_error_message: "Please enable storage from device settings.",
    give_permission: "Give Permission",
    please_wait_for_five_seconds_to_take_screenshot: "Please wait for 5 seconds to take another photo",
    please_wait_for: "Please wait for",
    seconds_to_take_screen_shot: "seconds to take another photo.",
    second_to_take_screen_shot: "second to take another photo.",
    invalid_information_received_from_server: "Invalid information received from the server.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet: "Unable to share video as no one else has joined the conversation yet",
    successfully_uploaded: "Successfully uploaded",
    disconnected: "Disconnected",
    call_ended_as_no_one_else_had_joined_the_call: "Disconnected as no one else joined.",
    application_update_required: "Application update required",
    update_required_message: "Looks like you are on an older version of the application, please update from the app store.",
    update: "Update",
    image_marking_started: "Image marking started",
    image_marking_stopped: "Image marking stopped",
    settings: "Settings",
    camera_permission_rationale: "We need access to your camera. Please give camera permission",
    microphone_permission_rationale: "We need access to your microphone. Please give microphone permission",
    location_permission_rationale: "We need access to your location. Please give location permission",
    storage_permission_rationale: "We need access to your storage. Please give storage permission",
    call_between_two_customers: "The agent has not joined, please retry again in some time.",
    media_projection_permission_needed_for_screen_sharing: "Media projection permission needed for screen sharing.",
    poor_network_connection: "Warning! Poor network connection",
    you_are_the_only_person_in_the_call: "You are the only person in the call",
    image_has_been_captured_and_started_uploading: "Image has been captured and started uploading",
    version: "Version",
    please_enter_the_code_provided_to_you: "Please enter the CODE provided to you.",
    start_screen_share: "Share Screen",
    stop_screen_share: "Stop Share",
    flip_camera: "Flip Camera",
    take_photo: "Take Photo",
    flash_off: "Flash Off",
    flash_on: "Flash On",
    start_markup: "Start Markup",
    stop_markup: "Stop Markup",
    speaker_off: "Speaker OFF",
    speaker_on: "Speaker ON",
    more: "More",
    close: "Close",
    video_off: "Video OFF",
    video_on: "Video ON",
    start_video: "Start Video",
    stop_video: "Stop Video",
    disconnect: "Disconnect",
    mute: "Mute",
    muted: "Unmute",
    powered_by_blitzz: "Powered by Blitzz",
    connecting_your_call: "Connected. Waiting for other participants.",
    connected: "Connected",
    pin_is_of_nine_digit: "The pin should be of 9 digit",
    preparing_image_for_markup: "Preparing image for markup…",
    clear_markup_confirmation: "Clear image Markups from all users?",
    clear_markup: "Clear markup",
    clear: "Clear",
    close_markup: "Close Markup",
    end_markup_confirmation: "Are you sure you want to close markup?",
    end: "End",
    agent_has_ended_markup_cannot_continue_without_agent: "Agent has ended markup. Cannot continue markup without agent",
    joining_image_markup: "Loading image for Markup…",
    cleared_markup: "Image Markups cleared for all users.",
    capturing_photo: "Capturing photo…",
    uploading: "Uploading",
    image: "image",
    image_ready_for_markup: "Image ready to Markup.",
    override_video: "This will stop other's video. Do you want to continue?",
    override_screen_share: "This will stop other's screen sharing. Do you want to continue?",
    started_screen_share: "Started Screenshare.",
    stopped_screen_share: "Stopped Screenshare.",
    clear_all: "Clear all",
    start_new_call_popup: "Start new call with CODE",
    group_call_limit_reached: "Group call limit reached",
    contact_admin_to_increase_participant_limit: "Please wait for any other participant to disconnect and then retry.",
    call_is_being_connected: "Call is being connected, please try again later.",
    show_recording_for_training_purpose: "This session is being recorded.",
    you_are_sharing_the_screen: "You're sharing the screen",
    location_colon: "Location:",
    date_colon: "Date:",
    image_for_markup_has_been_downloaded: "Image for markup has been downloaded",
    dismiss: "Dismiss",
    google_play_service_is_not_up_to_date: "Google play service not updated",
    rec: "Rec",
    you_are_offline: "You are offline.",
    markup: "Markup",
    exit: "Exit",
    video_unsupported: "Video unsupported",
    please_open_this_link_in_safari: "Please open this link in Safari.",
    you_are_not_able_to_see_this_video: "You are not able to see this video.",
    only_number_Allowed: "Only numbers are allowed.",
    permission_warning: "Permission warning",
    unable_to_join_call_please_try_after_sometime: "Unable to join call. Please try after sometime",
    share_live_video: "Share your live video?",
    share_your_screen: "Share your screen?",
    unable_access_flash: "Unable to access Flash Light.",
    camera_unavailable_try_again: "Camera is unavailable, Try again.",
    unable_download_image_tomarkup: "Unable to download image from the server, Please try again.",
    try_again: "Try again",
    markup_screen_appear_shortly: "Markup screen will appear shortly...",
    confirm: "Confirm",
    start: "Start",
    could_not_find_endpoint: "Could not find server endpoint.",
    please_wait: "Please wait...",
    done: "Done",
    ok: "Ok",
    please_try_again_with_valid_agent_id: "Please try again with valid Agent ID.",
    meeting_code_not_associated_with_agent: "Session ID is not associated with this Agent ID.",
    powered_by: "Powered by",
    failure: "Failure",
    code: "Session ID",
    start_new_call_question: "Start new call?",
    stop_sharing: "Stop sharing",
    reconnecting_call: "Reconnecting call...",
    unable_to_access_mircrophone_or_camera: "Unable to access your microphone or camera.",
    be_sure_to_allow_access_in_browser: "Be sure to allow access in your browser settings.",
    make_sure_you_have_microphone_camera_attached: "Make sure you have camera or microphone attached.",
    location_blocked_by_user: "Location blocked by user",
    user_has_joined_the_call: "User has joined the call",
    are_you_sure_you_want_to_close_window: "Are you sure you want to close this window?",
    reset_guide: "Reset guide",
    open_in_google_maps: "Open in Google Maps",
    location_image_upload_failed: "Location image upload failed",
    uploading_image: "Uploading image",
    upload_failed: "Upload failed",
    markup_is_in_progress: "Markup is inprogress...",
    select_language: "Select Language",
    checking_for_extension: "Checking for extension...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "To start screen share in incognito mode you need to start incognito mode from Blitzz - Screen Share extension of your browser.",
    click_on: "Click on",
    customize_and_control_menu: "Customize and control menu",
    more_tools: "More tools",
    extensions: "Extensions",
    click_on_detail: "Click on detail (Blitzz)",
    allow_in_incognito: "Allow in incognito.",
    screen_share: "Screen Share",
    stop_share: "Stop Share",
    save: "Save",
    cancel_initcap: "Cancel",
    yes_initcap: "Yes",
    message_title: "Message",
    device_not_compatible: "Sorry, this device is not compatible.",
    please_download_our_app: "Please download our app to continue.",
    download_app: "Download App",
    this_browser_is_not_supported: "This browser is currently not supported.",
    open_in_chrome_or_install_mobile_app:
        "Please copy and paste this link in the latest version of Google Chrome or Install our Mobile App and try again.",
    open_in_safari_or_install_mobile_app:
        "Please copy and paste this link in the latest version of Safari Browser or Install our Mobile App and try again.",
    open_in_chrome_and_try_again: "Please open this link in the latest version of Google Chrome and try again.",
    okay_initcap: "Okay",
    would_you_like_to_install_app_or_continue_browser: "Would you like to install our App to join Meeting or Continue with browser?",
    continue_initcap: "Continue",
    webview_limited_support_message: "For the best experience, please open in Chrome browser or your default browser.",
    continue_anyway: "Continue Anyway",
    open_in_browser: "Open in Browser",
    link_copied_open_in_browser: "Link copied! If browser didn't open, paste the link in Chrome.",
    add_blitzz_extension_to_screen_share: "Add Blitzz extension to screen share",
    add_to_chrome_and_confirm: "'Add to Chrome & Confirm'",
    add_extension: "Add Extension",
    permission_error_message_camera_browser: "Please enable camera from browser settings.",
    camera_not_found: "Camera not found",
    enable_camera_and_reconnect_call: "You need to enable your camera, reload the page and reconnect call.",
    permission_error_message_microphone_browser: "Please enable microphone from browser settings.",
    permission_error_message_location_browser: "Please enable location from browser settings.",
    microphone_not_found: "Microphone not found",
    enable_microphone_and_reconnect_call: "You need to enable your microphone, reload the page and reconnect call.",
    download_failed: "Download failed",
    continue_markup: "Continue Markup",
    save_and_exit: "Save and Exit Markup",
    exit_markup: "Exit Markup",
    you_are_recording_the_conversation: "You are now recording the conversation.",
    make_sure_participant_know_they_are_being_recorded: "Make sure participants know they’re being recorded.",
    you_can_download_recordings_later: "You can download the recorded file afterwards.",
    share_without_joining_session_lanuch_showme_enter_code:
        "Cannot screen share without joining a ShowMe Session. Please launch ShowMe by Blitzz, and enter the CODE provided to you.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "Group call limit reached. Please contact your Admin to increase the participant limit or wait for a member to leave the session.",
    other_user_trying_share_screen_Video: "Other user is trying to share screen or video",
    call_has_ended: "Call has ended",
    would_you_like_to_save_image: "Would you like to save the image?",
    audio_unsupported: "Audio Unsupported",
    please_install_our_app_to_continue: "Please install our app to continue.",
    unable_to_play_remote_audio: "Unable to play remote audio.",
    unable_to_playback_audio: "Unable to playback audio.",
    unable_to_play_video: "Unable to play video.",
    unable_to_playback_video: "Unable to playback video.",
    okay_cap: "Okay",
    pre_call_test: "Pre-call Test",
    language: "Language",
    reset: "Reset",
    zoom_in: "Zoom In",
    zoom_out: "Zoom Out",
    headset: "Headset",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "Started live pointer. You can move the pointer by dragging.",
    speaker: "Speaker",
    live_pointer_disabled_message: "Stopped live pointer",
    pointer: "Pointer",
    network_quality: "Network Quality",
    participant: "Participant",
    you: "(You)",
    reconnecting: "Reconnecting",
    very_bad: "Very bad",
    bad: "Bad",
    poor: "Poor",
    good: "Good",
    excellent: "Excellent",
    loc: "Loc",
    expand: "Expand",
    collapse: "Collapse",
    network: "Network",
    ocr_inprogress: "OCR is in progress...",
    select_area_extract_text: "Select area to extract text",
    text_copied: "Text Copied",
    extract_text_from_image: "Extracting text from image...",
    not_extract_text_from_image: "Could not extract text from the image. ",
    try_again_clear_image_or_reselect_region: "Please try again with a clear image, or reselect your extraction region.",
    error: "Error ",
    occured_while_receiving_doc: " occurred while receiving the document.",
    return_to_video: "Return to Video",
    save_entire_image: "Save Entire",
    save_cropped_image: "Save Cropped",
    text_copied_to_clipboard: "Click to Copy",
    extract_text: "Extract Text",
    stop_pointer: "Stop Pointer",
    do_not_rotate_the_phone_live_pointer_message: "For a better viewing experience, please do not rotate the device while live pointer is enabled.",
    got_it_btn: "Got it!",
    speed_test: "Speed Test",
    duration: "Duration",
    preparing_image_for_OCR: "Preparing image for text processing…",
    agent_extract_text_from_image: "Please wait, Agent is extracting text from captured image.",
    unable_download_image_to_ocr: "Unable to download the image for processing, Please try again.",
    selected_area_is_small: "Selected area is too small,",
    please_select_large_area: " please select large area of image.",
    zoom_level: "Zoom Level",
    do_not_rotate_the_phone_markup_message: "For a better viewing experience, please do not rotate the device while mark-up is enabled.",
    capturing: "Capturing...",
    upload_completed: "Upload completed",
    network_quality_not_available: "Network quality not available",
    not_able_to_see_your_stream: "will not be able to see your stream.",
    device_not_supported: "Device not supported.",
    video_settings_need_to_be_configured_by_admin_web:
        "Video settings need to be configured by your admin to support this device. Please contact your company admin or email",
    contact: "Contact",
    video_paused_by_agent: "Video paused by agent",
    not_shared: "Not shared",
    network_type: "Network Type",
    image_thumb_caption: "Image:",
    saved_images: "Saved Images",
    update_your_browser_to_share_your_screen: "Update your browser to the latest version to share your screen",
    try_these_option_to_have_better_experience: "Try one of these options for a better experience.",
    some_features_are_not_supported_in_this_browser: "Some features are not supported in this browser.",
    unsupported_browser: "Unsupported Browser",
    permission_message_for_screenshare:
        "Permissions to access the screen area was denied, or your current browser instance does not have permissions to access screen share.",
    go_to_system_preferences: "Go To System Preferences",
    security_privacy: "Security & Privacy",
    select_privacy_tab: "Select Privacy Tab",
    screen_recording: "Screen Recording",
    select_your_browser: "Select your browser",
    use_chrome_to_share_your_screen: "Use Chrome or Firefox browser to share your screen",
    there_was_an_error_trying_to_share_your_video: "There was an error trying to share your video.",
    please_stop_video_and_start_video_again_to_resume: "Please stop video and start video again to resume.",
    decline: "Decline",
    agree: "Agree",
    click_the_padlock: "Click the padlock",
    to_the_left_of_a_web_page_address: "to the left of the address bar.",
    clear_blocked_permission_for_share_the_screen: "Clear any blocked screen sharing permissions under the permissions section.",
    tips_colon: "Tips:",
    your_internet_connection_is_unstable: "Your internet connection is unstable",
    participants_connection_unstable: "Participant <participantNum>'s internet connection is unstable",
    enter_text_here: "Enter text here",
    text: "Text",
    rect: "Rect",
    draw: "Draw",
    try_our_mobile_app: "Open in App",
    still_facing_issue_connect_mobile_app: "If you are still facing an issue, connect using our mobile app.",
    open_in_app: "Open in App",
    enable_microphone_from_browser_settings: "Enable microphone from browser settings.",
    enable_camera_from_browser_settings: "Enable camera from browser settings.",
    unable_to_access_microphone: "Unable to access microphone",
    participants_title: "Participants",
    bookmarks_title: "Bookmarks",
    search_or_add_new_bookmark: "Search or add new bookmark",
    create_new_bookmark: "Create new Bookmark",
    press_enter_or_click_on_create_new_bookmark: "Press Enter or Click on Create new Bookmark to add new Bookmark",
    tap_retry_to_load: "Tap Retry to load",
    bookmark_saved_with_image: "Bookmark saved with image.",
    bookmark_saved: "Bookmark saved.",
    bookmark_added: "Bookmark added.",
    failed_to_bookmark_please_try_again: "Failed to bookmark. Please try again.",
    special_characters_are_not_allowed: "Special characters are not allowed.",
    home_screen: "Home Screen",
    privacy_policy_popup_text_description:
        "I understand and agree to voluntarily use my camera to share a view of my surroundings to resolve the technical issue(s) I am having. I understand no recording will be made or stored. I can turn off the sharing feature at any time. I will not point the camera at areas, individuals or items whose image I do not wish to share. I also confirm that I have read and agreed to the Privacy Policy.",
    audio_issue_ios: "Audio issue?",
    toggle_mic_icon_guest_msg: "Toggle the red mic/cam icon above, or use audio from telephone call.(PSTN)",
    toggle_mic_icon_agent_msg: "Request iOS user to toggle the red mic/cam icon above, or use audio from telephone call.(PSTN)",
    audio_ios_msg_read_more: "Read more",
    error_occured_in_processing_the_request: "Error occurred in processing the request. Please try again.",
    markup_ocr_upload_timeout: "Taking longer than usual.",
    cancel_markup: "Cancel Markup",
    markup_cancelled: "Markup cancelled",
    cancel_ocr: "Cancel Extract text",
    ocr_cancelled: "Extract text cancelled",
    click_here: "Click here",
    to_return_to_video_and_try_again: "to return to Video and try again.",
    test_connection: "Test Connection",
    markup_exit: "stopped Markup",
    ocr_exit: "stopped Extract text",
    camera: "Camera",
    camera_blocked: "Camera Blocked",
    microphone: "Microphone",
    microphone_blocked: "Microphone Blocked",
    speakers: "Speakers",
    speakers_blocked: "Speakers Blocked",
    grant_permission: "Grant Permission",
    play_test_sound: "Play Test Sound",
    call_settings: "Call Settings",
    allow_access_to_camera: "Allow access to your Camera.",
    allow_access_to_mic: "Allow access to your Microphone.",
    default_label: "Default",
    do_not_rotate_the_phone_OCR_message: "For a better viewing experience, please do not rotate the device while Extract text is enabled.",
    browser_not_supported: "Browser not supported",
    your_browser_not_support_video: "Your browser does not support video calling.",
    open_link_in_google_samsung_browser: "Please copy and paste this link in the latest version of Google Chrome or Samsung Internet browser.",
    open_link_in_safari_browser: "Please copy and paste this link in the latest version of Safari browser.",
    copy_link: "Copy link",
    copy_code: "Copy Code",
    session_code_copy: "Session ID copied to clipboard.",
    meeting_code_lable: "Meeting code",
    add_participant_lable: "Add participant",
    send_this_link_to_guest: "Send this link to the guest",
    send_an_email: "send an email",
    or_label: "or",
    remote_mic_cam_error: "Remote participant's microphone/camera has an error.",
    device_not_supported_or_permi_block: "Either their device is not supported, or they have permissions blocked.",
    remote_participant: "Remote participant",
    microphone_unmuted: "Microphone Unmuted",
    microphone_muted: "Microphone Muted",
    camera_on: "Camera On",
    camera_off: "Camera Off",
    error_label: "error",
    cannot_start_video: "Cannot start video",
    failed_to_start_video_camera: "Failed to start the video camera.",
    please_select_another_camera_from_call_settings: "Please select another video camera from Call Settings.",
    please_select_another_video_camera: "Please select another video camera.",
    chat: "Chat",
    chat_info: "Chat messages are visible to everyone on the call. Chat history will disappear permanently when you disconnect, by design.",
    chat_input_placeholder: "Type a message",
    participant_connected: "<participantCount> participant(s) connected",
    click_to_share_invite: "Click to share invite",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "Remote flashlight not supported on guest device or not ready",
    pin_a_video_tile_above_to_use_this_feature: "Pin a video tile above to use this feature",
    pin_video_for_all_participants: "Pin video for all participants",
    return_to_gallery_view: "Return to Gallery View",
    override_own_screen_share: "Your screen share will be stopped. Do you want to continue?",
    override_own_video: "Your video will be stopped. Do you want to continue?",
    blur: "Blur",
    mask_lable: "Mask",
    arrow: "Arrow",
    view_text: "View",
    recording_stopped: "Recording stopped",
    error_recording_please_try_again: "Error recording, please try again",
    error_recording_wait_or_disconnect_call: "Error recording. Please wait for the host to stop recording, or you may disconnect and rejoin later.",
    wait_for_recording: "Please wait while we start Recording...",
    max_participant_limit_for_recording:
        "Max. participant limit reached while recording. Please wait for the host to stop recording, or you may disconnect and rejoin later.",
    error_recording_all_participants: "Error recording all participants. ",
    please_stop_and_restart_recording: "Please stop and restart recording.",
    some_participants_will_not_be_recorded: "Some participants will not be recorded.",
    participant_limit_reached: "Participant limit reached.",
    your_account_has_4_participant_limit_while_recording: "Your account has 4 participants limit while recording.",
    disconnect_call: "Disconnect Call",
    record_title: "Record",
    stop_recording_btn: "Stop Recording",
    back_to: "Back to",
    cam_per_denied_msg: "One of your participants may have blocked camera access on their device. To guide them, please view",
    mic_per_denied_msg: "One of your participants may have blocked microphone access on their device. To guide them, please view",
    cam_mic_per_denied_msg: "One of your participants may have blocked camera and microphone access on their device. To guide them, please view",
    per_denied_common_msg: "for quick tips to reset browser permissions.",
    your_camera_block: "Your camera is blocked",
    your_microphone_block: "Your microphone is blocked",
    your_location_block: "Your location is blocked",
    we_cannot_access_your_camera: "We can't access your camera.",
    we_cannot_access_your_microphone: "We can't access your microphone.",
    we_cannot_access_your_location: "We can't access your location.",
    go_to_browser_settings: "To give access, Go to your browser settings and then click here to reload the page.",
    still_facing_issue: "Still facing issue?",
    try_the: "Try the",
    mobile_app: "mobile app",
    view_help_article: "View help article",
    enable_or_attach_camera_and_reconnect_call: "You need to enable or attach the camera, reload the page and reconnect call.",
    enable_or_attach_microphone_and_reconnect_call: "You need to enable or attach the microphone, reload the page and reconnect call.",
    start_rec_label: "Start Rec.",
    stop_rec_label: "Stop Rec.",
    start_recording_tooltip_label: "Start Recording",
    click_here_label: "click here",
    cam_per_denied_title: "Remote participant camera blocked",
    mic_per_denied_title: "Remote participant microphone blocked",
    cam_mic_per_denied_title: "Remote participant camera and microphone blocked",
    these_instructions: "these instructions",
    Whisper_on: "Whisper On",
    Whisper_off: "Whisper Off",
    enable_whisper_tooltip_label: "Enable whisper to speak with the host",
    host_can_hear_you_now: "Host can hear you now",
    mediate_lable: "Mediate",
    join_call_as_participant: "Join call as participant",
    observer_lable: "Observer",
    silent_observer_connect_alert_popup: "Connected as an observer. Your microphone and camera are muted.",
    click_mediate_if_you_would_like_to_join_as_a_participant: 'Click "Mediate" if you would like to join as a participant.',
    guest_lable: "Guest",
    Silent_observer_lable: "Silent Observer",
    invite_participant_tooltip_lable: "Microphone and camera will be muted for Silent Observer, and they will not be visible to guest participants.",
    send_link_silent_observer: "Send this link to silent observer.",
    join_as_mediator_title: "Join as a Mediator?",
    join_as_mediator_popup_description:
        "Are you sure you want to join the call as a participant? Click Confirm below, and then click Connect in the next screen to join as a participant (mediator).",
    from_participant: "From Participant",
    download_key: "Download",
    download_not_supported_text: "Download is not supported on your device.",
    undo: "Undo",
    redo: "Redo",
    color_label: "Color",
    overall_experience: "Overall experience?",
    leave_comment: "Leave a Comment (Optional)",
    sent: "Sent",
    send: "Send",
    view_unavailable: "View unavailable",
    whisper_label: "Whisper",
    thanks: "Thanks!",
    stop_recording_tooltip_label: "Return to gallery mode to stop rec.",
    save_image: "Save Image",
    screenshare_mweb_text: "Screen share from your device requires an App. Please connect this session from the mobile app.",
    disconnect_and_launchapp_btn: "Disconnect and Launch App",
    device_battery_low: "Device battery low",
    batteryinfo_tooltip: "Device battery information",
    notes_lable: "Notes",
    new_note_lable: "New note",
    only_visible_to_you: "Only visible to you",
    empty_note: "Empty note",
    title_lable: "Title",
    delete_lable: "Delete",
    delete_Note: "Delete Note",
    want_delete_this_note: "Are you sure you want to delete this note?",
    failed_delete_note: "Failed to delete note.",
    note_deleted_successfully: "Note deleted",
    failed_edit_note: "Failed to edit note.",
    note_edited_successfully: "Note updated",
    failed_add_note: "Failed to add note.",
    note_added_successfully: "Note added",
    screenshare_mweb_title: "App download required",
    screenshare_mweb_desc1: "Screen share from your device requires an App.",
    screenshare_mweb_desc2: "to download the app.",
    upcoming_event: "Upcoming event",
    scheduled_to_start_in: "Scheduled to start in",
    please_wait_for_the_host_to_start_this_event: "Please wait for the host to start this event and try again.",
    image_deleted: "Image deleted",
    failed_to_delete_image: "Failed to delete image",
    are_you_sure_you_want_to_delete_image: "Are you sure you want to permanently delete this image?",
    delete_image_title: "Delete Image",
    location_image_thumb_caption: "Location Image",
    schedule_to_start_in_a_few_seconds: "Scheduled to start in a few seconds.",
    edit_label: "Edit",
    scan_code_lable: "Scan code",
    scan_code_result: "Scan code result",
    extract_text_result: "Extract text result",
    scan_code_result_not_found: "Could not scan QRcode/Barcode from the image. Please try again with a clear image.",
    host_features_will_not_be_available_when_using_app: "Host features will not be available when using App.",
    note_colon: "Note:",
    leave_lable: "Leave",
    are_you_sure_you_want_to_leave_this_call: "Are you sure you want to leave this call?",
    supported_browser_versions: "Supported browser versions.",
    see: "See",
    has_sent_you_link_for_video_conference: "<company_name> has sent you a link for live video conference.",
    join_the_session: "Join the session",
    other: "Other",
    share_invitation_with_others: "Share Session Invitation with others",
    copy_invitation: "Copy session invitation",
    copy_invitation_desc: "Copy the invitation text with scheduled time and send it manually",
    copied: "Copied!",
    copy_session_code: "Copy Session ID",
    copy_link_to_share: "Copy link to share",
    reference: "Reference",
    session_invitation_copied: "Session Invitation copied to clipboard.",
    guest_url_copy: "Guest URL copied to clipboard.",
    observer_url_copied: "Observer URL copied to clipboard.",
    sms_sent_label: "SMS Sent!",
    email_sent_label: "Email Sent!",
    invite_sent_successfully: "Invite sent successfully",
    sms_label: "SMS",
    copy: "Copy",
    email: "Email",
    enter_valid_email: "Enter valid email address.",
    limit_exceeded: "Limit exceeded",
    enter_email_send: "Enter Email to Send an Invite",
    send_invitaion_lable: "Send Invitation",
    enter_mobile_number_lable: "Enter Mobile Number",
    enter_valid_mobile: "Enter valid mobile number.",
    new_email_address: "Email Address",
    mobile_number: "Mobile Number",
    video_quality: "Video Quality",
    low_bandwidth: "Low Bandwidth",
    adaptive: "Adaptive",
    high_quality: "High Quality",
    wait_for_the_call_to_start: "Wait for the call to start",
    call_disconnected: "Call Disconnected",
    dont_show_this_again: "Don't show this again",
    invite_participant_lable: "Invite Participant",
    saved_label: "Saved!",
    show_stream: "Show",
    hide_stream: "Hide",
    camera_permission_required_title: "Camera permission required",
    camera_permission_required_disc1: "To share live video, please turn on the camera permission in your browser settings then ",
    reload_page_disc: "to reload the page.",
    location_permission_required_title: "Location permission required",
    microphone_permission_required_title: "Microphone permission required",
    confirmation_lable: "I can confirm that I have read and agree to the",
    live_location: "Live Location",
    no_one_shared_location: "No one has shared their location",
    it_was_great_lable: "It was great",
    not_so_great_lable: "Not so great",
    link_copied: "Link Copied",
    microphone_publication_description: "Microphone not found or may be in use by other application.",
    please_close_all_other_application: "Please close all other applications which may be using microphone and try again.",
    app_to_share_your_device_screen: "Continue this call in App to share your device screen",
    launch_app: "Launch App",
    screen_share_requires_app: "Screen share requires an App.",
    only_takes_few_seconds: "This only takes a few seconds.",
    download_app_from_app_store_and_then_return_page: "Download the App from the App Store and then return to this page.",
    click_to_download_app: "Click to Download App",
    go_to_Step_2: "If you have already downloaded the App, go to Step 2",
    next_lable: "Next",
    rejoin_the_call_in_app: "Rejoin the call in App",
    step2_screen_share_description:
        "After you have downloaded the App, you can rejoin this call in the App and select “Screen Share” to share your mobile screen.",
    disconnect_the_call_in_browser: "This will disconnect the call in browser",
    back_btn_lable: "Back",
    rejoin_call_in_app: "Rejoin call in App",
    step_one: "Step 1",
    step_two: "Step 2",
    beta_release_tag_des1: "This feature is currently in Beta Release.",
    email_support_feedback: "Please email support@blitzz.co to share your feedback.",
    would_you_like_to_exit_markup: "Would you like to exit markup?",
    current_position: "Current Position",
    start_point: "Start Point",
    live_captions: "Live Captions",
    starting_label: "Starting...",
    live_captions_started: "Live Captions started.",
    spoken_language_is_set_to_english: "Spoken language is set to English.",
    click_to_open_more_information: "Click to open more information",
    open_in_safari_chrome_or_install_mobile_app:
        "Please copy and paste this link in the latest version of Safari or Google Chrome Browser or Install our Mobile App and try again.",
    continue_without_name: "Continue Without Name",
    enter_your_name: "Enter Your Name",
    ignore: "Ignore",
    screen_share_info:
        "To avoid an infinity mirror, don't share your entire screen or browser window. Share just a tab or a different window instead.",
    screen_share_to_everyone: "You're sharing the screen to everyone",
    stop_share_screen: "Stop Share Screen",
    unable_to_start_the_video_please_download_the_app_to_continue: "Unable to start the video, please download the app to continue.",
    upload: "Upload",
    from_device: "From Device",
    from_camera: "From Camera",
    upload_failed_files: "Upload Failed Files",
    uploaded_max_file: "You have uploaded the maximum number of files allowed.",
    upload_files: "Upload Files",
    upload_limit_reached: "Upload limit reached",
    drop_for_upload_or_select: "Drop here to upload, or select",
    upload_20_file: "Upload up to 20 files at a time.",
    max_size_20MB: "Max. file size <fileSize> MB.",
    cancel_upload: "Cancel Upload",
    cancel_upload_alert: "Cancel Upload?",
    file_details_deleted: "Any details added to your files will be deleted.",
    uploaded_files: "Uploaded Files",
    capture_image: "Capture Image",
    participant_uploading_file_msg: "Please wait while the other participant is uploading files.",
    previous: "Previous",
    max_file_count: "You can upload maximum <fileCount> files at a time.",
    removed_more_than_20MB_file: "Files more than <fileSize> MB in size are removed.",
    uploading_files: "Uploading File(s)",
    upload_failed_file_count: "Upload failed: <numberOfFailedFiles> files were not uploaded.",
    add_caption: "Add Caption...",
    uploaded_files_of_a_maximum: "Uploaded <successCount> file(s), of a maximum <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "You have selected the maximum number of files allowed.",
    upload_max_count: "Upload maximum <remainingCount> file(s).",
    image_upload_msg: "Please wait while the images are being uploaded",
    finished_uploading: "Finished uploading",
    upload_files_msg: "Upload files",
    uploading_dots: "Uploading…",
    loading_image_counter: "Loading image <counter> of <totalCount>",
    closing_tab: "Closing tab",
    close_tab: "Close Tab",
    return_to_home_screen: "Returning to home screen",
    session_code_expire_msg: "This link has been closed",
    view_call_logs: "View call logs",
    measurements: "Measurements",
    copy_all: "Copy All",
    measure: "Measure",
    view_supported_device: "View supported devices",
    device_not_support_google_play_service: "Participant device does not support Google Play Service which is required for 3D Measurements",
    device_not_compatible_for_measurement: "Device not compatible for Measurement",
    device_required_update_google_play_service: "Participant device requires updating Google Play Service to start 3D Measurement.",
    device_required_google_play_service: "Participant device requires installing Google Play Service to start 3D Measurement",
    app_required_update_for_measurement: "Supporting App update required for Measurement",
    app_required_for_measurement: "Supporting App required for Measurement",
    preparing_ar_measurement: "Preparing view for Measurement...",
    measurement_copied_msg: "Measurements copied to clipboard",
    ready_for_measurement: "Ready for measurement",
    move_device_to_start: "Move device to start",
    tacking_not_available: "Tracking is not available",
    camera_use_bu_another_app: "Camera is in use by another app",
    more_light_required: "More light required",
    move_further_away: "Move further away",
    slow_down: "Slow down",
    measurement_cancelled: "Measurement Cancelled",
    app_required: "This feature requires app download. <learnmore>",
    learn_more: "Learn more",
    ar_measurement_description_step2:
        'After you have downloaded the App, you can rejoin this call in the App and select "Measure" to start AR Measurement',
    ar_measurement_description_step1: "Augmented Reality Measurement feature allows you to measure objects in 3D and requires an App Download",
    app_to_support_ar_measurement: "Continue this call in App to support AR Measurement",
    find_surface_to_measure: "Find a near by surface to measure",
    measurement_toast_note_to_guide_user: "Note: Measurements are approximate.",
    measurement_toast_msg_to_guide_user:
        "For best results, use Measure on well-defined objects located 0.5 to 3 meters (2 to 10 feet) from your phone.",
    having_audio_issue: "Having an audio issue?",
    remote_participant_voice_not_coming_description:
        "Looks like you are facing difficulties hearing other participant's voice or experiencing some kind of audio issue currently.",
    workaround_action_for_remote_audio_not_coming: "<click_here> to apply a quick workaround.",
    click_here_for_audio_label: "Click here",
    measurement_copyall_msg: "Measurement(s) copied to clipboard",
    armarkup_cancelled: "AR Markup Cancelled",
    device_not_support_google_play_service_for_markup: "Participant device does not support Google Play Service which is required for 3D Markup",
    device_required_update_google_play_service_for_markup: "Participant device requires updating Google Play Service to start 3D Markup.",
    device_required_google_play_service_for_markup: "Participant device requires installing Google Play Service to start 3D Markup",
    device_not_compatible_for_AR_Markup: "Device not compatible for AR Markup",
    app_required_update_for_AR_Markup: "Supporting App update required for AR Markup",
    app_required_for_AR_Markup: "Supporting App required for AR Markup",
    preparing_view_for_ar_markup: "Preparing view for AR Markup...",
    AR_Markup_Lable: "AR Markup",
    armarkup_toast_msg_to_guide_user: "For best results, use Markup on well-defined objects located 0.5 to 3 meters (2 to 10 feet) from your phone.",
    ar_live_streaming_ready_to_markup: "AR live streaming ready to markup.",
    ar_markups_cleared_for_all_users: "AR Markups cleared for all users.",
    ar_live_streaming_marking_stopped: "AR live streaming marking stopped",
    agent_has_ended_ar_markup_cannot_continue_without_agent: "Agent has ended AR markup. Cannot continue AR markup without agent",
    ar_markup_cancelled: "AR Markup cancelled",
    ready_for_ar_markup: "Ready for AR Markup",
    max_ar_arrow_limit_toast_message: "Arrow limit reached, please use clear all to add more.",
    video_paused: "video paused",
    discard_label: "Discard",
    discard_image_label: "Discard Image",
    save_image_label: "Save Image",
    go_room_call_limit_reached: "Go room call limit reached",
    circle: "Circle",
    arrow_with_text: "Arrow with text",
    add_shadow_and_stroke: "Add shadow and stroke",
    font_label: "Font:",
    file_type_not_supported: "File(s) type not supported",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "Please click on the New Note button below to start taking notes",
    remote_user_stream_interrupted: "Remote user stream interrupted",
    audio_disabled_by_admin: "Audio disabled by Admin",
    audio_disabled: "Audio disabled",
    dont_show_again: "Don't Show Again",
    whatsapp_sent_label: "WhatsApp Invitation Sent!",
    whatsapp_label: "WhatsApp",
    having_an_issue_with_joining_the_call: "Having an issue with joining the call?",
    to_perform_network_check: "to perform network check",
    you_were_removed_from_the_call_by_the_host: "You were removed from the call by the host",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now: "You have been removed from the call by the host and cannot rejoin now.",
    host_removed_you_from_the_call: "Host removed you from the call.",
    unable_to_join_the_call: "Unable to join the call",
    host_muted_your_microphone: "Host muted your microphone.",
    unmute_your_microphone: "Unmute your microphone",
    host_invites_you_to_speak_unmute_your_microphone_when_ready: "Host invites you to speak. Unmute your microphone when ready.",
    got_it: "Got it",
    unmute_mic: "Unmute mic",
    host_turned_off_your_camera: "Host turned off your camera.",
    turn_your_camera_on: "Turn your camera on",
    host_invites_you_to_turn_your_camera_on: "Host invites you to turn your camera on.",
    turn_camera_on: "Turn camera on",
    start_sharing_your_screen: "Start sharing your screen",
    host_invites_you_to_share_your_screen: "Host invites you to share your screen.",
    share_screen: "Share screen",
    remove_all: "Remove all",
    remove: "Remove",
    end_call: "End call",
    removing_all_participants_will_end_the_call: "Removing all participants will end the call.",
    are_you_sure_you_want_to_remove_from_this_call: "Are you sure you want to remove <participantName> from this call?",
    block_from_rejoining_this_call: "Block <participantName> from rejoining this call",
    turn_all_mics_off: "Turn all mics off",
    turn_all_cams_off: "Turn all cams off",
    ask_to_turn_mic_on: "Ask to turn mic on",
    turn_mic_off: "Turn mic off",
    turn_cam_off: "Turn cam off",
    ask_to_turn_cam_on: "Ask to turn cam on",
    ask_to_share_screen: "Ask to share screen",
    having_a_video_problem: "Having a video problem?",
    ios_play_pause_modal_body_text:
        "Try to disable the power saving mode of your mobile to fix this or Please click on Play button below to play the video for now.",
    play_video: "Play video",
    camera_request_sent: "Camera request sent.",
    waiting_for_host_approval: "Waiting for host approval.",
    microphone_request_sent: "Microphone request sent.",
    camera_request_denied: "Camera request denied.",
    click_the_camera_icon_if_you_need_to_request_again: "Click the camera icon if you need to request again.",
    microphone_request_denied: "Microphone request denied.",
    click_the_mic_icon_if_you_need_to_request_again: "Click the mic icon if you need to request again.",
    deny: "Deny",
    allow: "Allow",
    user_wants_to_start_their_camera: "<ParticipantName> wants to start their <micOrCam>",
    error_in_processing_live_caption_please_retry: "Error in processing live caption, please retry.",
    virtual_background: "Virtual Background",
    upload_image: "Upload Image",
    remove_image: "Remove Image",
    remove_background_image: "Remove Background Image",
    are_you_sure_you_want_to_remove_background_image: "Are you sure you want to remove Background Image?",
    unsupported_file_format: "Unsupported file format.",
    the_maximum_file_size_supported_is_in_mb: "The maximum file size supported is <size> MB.",
    no_effect: "No Effect",
    blur_background: "Blur Background",
    default_image: "Default Image",
    virtual_background_not_supported: "Virtual background not supported.",
    remove_from_call: "Remove from call",
    enable_offline_mode: "Enable Offline Mode",
    offline_mode_enabled: "Offline Mode Enabled",
    your_images_will_upload_when_you_reconnect: "Your images will upload when you reconnect.",
    please_keep_this_screen_open: "Please keep this screen open.",
    max_images_upload: "Max <count> images",
    remaining_image_count_label: "<remainingCount> of <totalCount> Images",
    selected_images: "Selected Images",
    offline_uploads_are_not_supported_in_private_mode: "Offline uploads are not supported in Private Mode.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Please switch to a normal browser tab to use this feature.",
    guest_is_using_a_private_browser_window: "Guest is using a private browser window.",
    offline_upload_mode_is_not_supported_in_this_case: "Offline upload mode is not supported in this case.",
    some_images_failed_to_upload_due_to_a_network_error: "Some images failed to upload due to a network error.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "Closing this modal will discard all the images you have selected during offline mode.",
    live_captions_stopped: "Live Captions stopped.",
    ask_ai: "Ask AI",
    ask_ai_info: "Get AI-powered assistance by capturing screenshots from the video stream and asking questions.",
    quick_assist: "Quick Assist",
    quick_assist_tooltip: "Instantly capture and analyze the current screen",
    screenshot_ask: "Snap & Ask",
    screenshot_ask_tooltip: "Take a screenshot and ask a specific question about it",
    text_only: "Text Only",
    ask_ai_input_placeholder: "How can I help you today?",
    ask_ai_screenshot_placeholder: "Type your question about the screenshot...",
    retake: "Retake",
    or: "OR",
    translate: "Translate",
    auto_translate: "Auto-Translate",
    your_language: "Your language",
    translation_info_text: "Messages from other participants will be automatically translated to your selected language.",
    translating: "Translating...",
    show_original: "Show Original",
    show_translation: "Show Translation",
    translated: "Translated",
    send_message_in: "Send message in",
    audio_translation: "Translate",
    audio_translation_setup: "Audio Translation",
    they_speak: "They speak",
    i_want_to_hear: "I want to hear",
    start_translation: "Start Translation",
    stop_translation: "Stop Translation",
    starting_translation: "Starting translation...",
    translation_started: "Audio translation started.",
    translation_stopped: "Audio translation stopped.",
    translation_error: "Translation error occurred. Please try again.",
    translation_active: "Translation active",
    voice_type: "Voice",
    voice_female: "Female",
    voice_male: "Male",
};

export default en;
